import { validateRequired } from '../../../../helpers/formValidation'
import { ValidateLeaveForm } from '../typings'

export const validateform = ({
  values,
  errors,
  field
}: ValidateLeaveForm): Record<string, string> => {
  const formErrors: Record<string, string> = { ...errors }
  const { leaveType, fromDate, toDate, dayStatus, leaveName } = values || {}

  switch (field) {
    case 'leaveType':
      formErrors['leaveType'] = validateRequired(leaveType)
      break
    case 'fromDate':
      formErrors['fromDate'] = validateRequired(fromDate)
      break
    case 'toDate':
      formErrors['toDate'] = validateRequired(toDate)
      break
    case 'dayStatus':
      formErrors['dayStatus'] = validateRequired(dayStatus)
      break
    case 'leaveName':
      formErrors['leaveName'] = validateRequired(leaveName)
      break

    default:
      formErrors['leaveType'] = validateRequired(leaveType)
      formErrors['fromDate'] = validateRequired(fromDate)
      formErrors['toDate'] = validateRequired(toDate)
      formErrors['dayStatus'] = validateRequired(dayStatus)
      formErrors['leaveName'] = validateRequired(leaveName)
  }

  return formErrors
}
